module.exports = __webpack_public_path__ + "img/kw.7ad30d43.svg";